import React from 'react'
import styles from './index.module.scss'

interface ModalProps {
  children: JSX.Element[] | JSX.Element
  showModal: boolean
  closeModal: () => void
  title: string
  modalClass?: string
  id?: string
  size?: 'normal' | 'middle'
  overflow?: boolean
  showHeader?: boolean
}
const StandardModal = ({
  children,
  showModal,
  closeModal,
  title,
  modalClass,
  id,
  size = 'normal',
  overflow = true,
  showHeader = true,
}: ModalProps) =>
  showModal ? (
    <div
      id={id}
      className={
        showModal
          ? showHeader
            ? styles.modal_container
            : styles.modal_container__withoutHeader
          : styles.modal_container_hidden
      }>
      <div
        className={`${
          modalClass
            ? `${styles.modal_content} ${styles[modalClass]} ${styles[size]}`
            : styles.modal_content
        } ${!overflow ? styles.no_overflow : ''}`}>
        {showHeader && (
          <div className={styles.title_container}>
            <h1 className={styles.title}>{title}</h1>
            <a onClick={closeModal} className={styles.modal_close}>
              &times;
            </a>
          </div>
        )}
        {children}
      </div>
    </div>
  ) : null

export default StandardModal
